export default __webpack_public_path__ + "static/media/p5.bcc57f0a.svg";